import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between h-full" }
const _hoisted_2 = { class: "px-6 md:px-8 pt-6" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "text-gray-900 font-medium truncate" }
const _hoisted_5 = { class: "truncate" }
const _hoisted_6 = {
  key: 0,
  class: "text-blue-600 truncate"
}

import { computed, onMounted, ref } from 'vue'

import TablistGrid from '@/components/neue/TablistGrid.vue'
import api from '@/store/api'
import { mapRelationship } from '@/store/mappers'

// Server-side cursor pagination. The previous implementation fetched the
// merchant's entire credit set in one request and sliced it on the client,
// which timed out for merchants with thousands of credits. We now fetch one
// page at a time and accumulate pages forward, mirroring ProductList.
const pageSize = 25

export default {
  __name: 'AccountCreditList',
  setup(__props) {

const credits = ref([])
const loading = ref(true)
const page = ref(0)
const cursor = ref(null)
const size = ref(0)

const view = computed(() => credits.value[page.value] || [])

const url = c => `account_credits?included=conversation_user_pair&page_size=${pageSize}&cursor=${c}&direction=next`

const prev = ret => {
  page.value--
  ret()
}

const next = ret => {
  // Fetch the next page only if it has not been loaded yet and the server
  // handed us a cursor for more records; otherwise step into a loaded page.
  if (credits.value.length <= page.value + 1 && cursor.value) {
    api.call('GET', url(cursor.value)).then(x => {
      credits.value.push(x.data.data)
      cursor.value = x.data.next_cursor
      page.value++
      ret()
    })
  } else {
    page.value++
    ret()
  }
}

onMounted(() => {
  api.call('GET', url(0)).then(x => {
    credits.value.push(x.data.data)
    cursor.value = x.data.next_cursor
    size.value = x.data.total_records
    loading.value = false
  })
})

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_TablistHeader = _resolveComponent("TablistHeader")
  const _component_router_link = _resolveComponent("router-link")
  const _component_TablistRow = _resolveComponent("TablistRow")
  const _component_NeueTablist = _resolveComponent("NeueTablist")
  const _component_NeuePagination = _resolveComponent("NeuePagination")
  const _component_EmptyState = _resolveComponent("EmptyState")
  const _component_NeueWell = _resolveComponent("NeueWell")
  const _component_NeueLoading = _resolveComponent("NeueLoading")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, { text: "Account credits" })
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_NeueLoading, { loading: loading.value }, {
            default: _withCtx(() => [
              (size.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_NeueTablist, null, {
                      head: _withCtx(() => [
                        _createVNode(_component_TablistHeader, null, {
                          default: _withCtx(() => [
                            _createVNode(TablistGrid, {
                              columns: ['ID', 'Value', 'Customer'],
                              header: ""
                            }, {
                              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                _createElementVNode("div", null, "ID", -1),
                                _createElementVNode("div", null, "Value", -1),
                                _createElementVNode("div", null, "Customer", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(view.value, (credit) => {
                          return (_openBlock(), _createBlock(_component_TablistRow, {
                            key: credit.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(TablistGrid, { columns: ['ID', 'Value', 'Customer'] }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_4, "#" + _toDisplayString(credit.id), 1),
                                  _createElementVNode("div", _hoisted_5, _toDisplayString(credit.attributes.value_amount.format), 1),
                                  (credit.relationships.conversation_user_pair.data?.id)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        _createVNode(_component_router_link, {
                                          to: '/profile/' + credit.relationships.conversation_user_pair.data?.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(mapRelationship)(credit.relationships.conversation_user_pair.data)?.attributes.display_name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_NeuePagination, {
                      size: size.value,
                      from: 1 + page.value * pageSize,
                      to: (1 + page.value) * pageSize,
                      onPrev: prev,
                      onNext: next
                    }, null, 8, ["size", "from", "to"])
                  ]))
                : _createCommentVNode("", true),
              (!size.value)
                ? (_openBlock(), _createBlock(_component_NeueWell, {
                    key: 1,
                    class: "text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EmptyState, { plural: "account credits" })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

}